import { equipmentConditions } from '../../data/filterOptions';
import { FilterSection } from './FilterSection';
import { useTranslation } from 'react-i18next';

interface ConditionFilterProps {
  selectedConditions: string[];
  onChange: (value: string) => void;
}

export function ConditionFilter({ selectedConditions, onChange }: ConditionFilterProps) {
	const { t } = useTranslation();
  return (
    <FilterSection title={t('store.filters.equipmentCondition')}>
      {equipmentConditions.map((condition) => (
        <div key={condition.id} className="flex items-center">
          <input
            id={`condition-${condition.id}`}
            type="checkbox"
            checked={selectedConditions.includes(condition.id)}
            onChange={() => onChange(condition.id)}
            className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-indigo-500"
          />
          <label
            htmlFor={`condition-${condition.id}`}
            className="ml-3 text-sm text-gray-600"
          >
			{t(`store.filterOptions.conditions.${condition.id}`, { defaultValue: condition.label })}
          </label>
        </div>
      ))}
    </FilterSection>
  );
}